/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography, {TypographyProps} from '@material-ui/core/Typography';
import classnames from 'classnames';
import {dlsAlt} from '@ion/dls/src/theme/theme';
import {LabelTypographyVariantEnum} from '../types/types';

export interface LabelTypographyProps extends TypographyProps {
  children: any;
  variantType?: keyof typeof LabelTypographyVariantEnum;
}

const useStyles = makeStyles(theme => ({
  label1 : {
    ...dlsAlt('typography', 'label1')
  },
  label2 : {
    ...dlsAlt('typography', 'label2')
  },
  label3 : {
    ...dlsAlt('typography', 'label3')
  }
}));

/**
 *
 * @LabelTypography
 *
 * DLS Foundational Design Typography Label text:
 *
 * ```typescript
 *
 * import React from 'react';
 * import {LabelTypography} from '@ion/dls/src/typography/LabelTypography';
 *
 * function MyComponent {
 *   return (
 *     <React.Fragment>
 *       <LabelTypography>label3</LabelTypography>
 *     </React.Fragment>
 *   );
 * }
 *
 * ```
 *
 */
const LabelTypography = ({
  children,
  variantType = 'label3',
  ...props
}: LabelTypographyProps) => {
  const classes = useStyles();
  return (
    <Typography {...props}
      className={classnames(classes[variantType], props.className)}>
      {children}
    </Typography>
  );
};
export {LabelTypography};
